import Vue from "vue";
import GaauPriorityEnum from "../enums/GaauPriorityEnum"
class GaauService {
  Remove(id, version) {
    let url = "gaau/remove/" + id;
    if (version && version > 0)
      url = url + "/version/" + version;

    return Vue.prototype.$http({
      url: url,
      method: "DELETE"
    });
  }

  RemoveFile(id, gaauId) {
    return Vue.prototype.$http({
      url: "gaau/remove-file?id=" + id + "&gaauId=" + gaauId,
      method: "DELETE"
    });
  }

  Get(id, version) {
    var url = "gaau/get/" + id;
    if (version > 0)
      url = url + "/version/" + version;
    return Vue.prototype.$http({
      url: url,
      method: "GET"
    });
  }

  GetFiles(id, version) {
    var query = "?gaauId=" + id;
    if (version)
      query += "&version=" + version;

    return Vue.prototype.$http({
      url: "gaau/get-files" + query,
      method: "GET"
    });
  }

  New(viewModel) {
    return Vue.prototype.$http({
      url: "gaau/new",
      data: viewModel,
      method: "POST"
    });
  }

  Edit(viewModel) {
    return Vue.prototype.$http({
      url: "gaau/edit",
      data: viewModel,
      method: "PUT"
    });
  }

  NewHistory(id) {
    return Vue.prototype.$http({
      url: "gaau/new-history/" + id,
      method: "POST"
    });
  }

  GetGrid(page, projectId) {
    let url = "/gaau/get-grid?page=" + page + "&perPage=" + 20;
    if (projectId)
      url = url + "&projectId=" + projectId;
    return Vue.prototype.$http({
      url: url,
      method: "GET"
    });
  }

  GetHistoryGrid(page, perPage, gaauId) {
    let url = "/gaau/get-history-grid?page=" + page + "&perPage=" + perPage + "&gaauId=" + gaauId;
    return Vue.prototype.$http({
      url: url,
      method: "GET"
    });
  }

  GetReportTable(projectId) {
    return Vue.prototype.$http({
      url: "/gaau/report/table/" + projectId,
      method: "GET"
    });
  }

  GetReportTables(projects) {
    return Vue.prototype.$http({
      url: "/gaau/report/table",
      data: { ids: projects },
      method: "POST"
    });
  }

  ResultName(result) {
    if (result >= 0 && result <= 20) return GaauPriorityEnum.Low;
    if (result >= 21 && result <= 40) return GaauPriorityEnum.Average;
    if (result >= 41 && result <= 60) return GaauPriorityEnum.High;

    //>= 61
    return GaauPriorityEnum.Priority;
  }

  ResultColor(result) {
    if (result >= 0 && result <= 20) return "badge badge-success";
    if (result >= 21 && result <= 40) return "badge badge-yellow";
    if (result >= 41 && result <= 60) return "badge badge-orange";

    //>= 61
    return "badge badge-danger";
  }

  Reorder(projectId) {
    return Vue.prototype.$http({
      url: "/gaau/reorder/" + projectId,
      method: "POST"
    });
  }

}

export default new GaauService();
